/* =====================================================================
 * Sidebar avatar helpers
 *
 * Deterministic color + initial generation for user avatars. Kept pure
 * so other surfaces (comments, share dialogs, team member lists) can
 * derive the same avatar appearance without coupling to Sidebar.tsx.
 * ===================================================================== */

const AVATAR_PALETTE = [
  '#f87171', '#fb923c', '#fbbf24', '#a3e635',
  '#34d399', '#22d3ee', '#60a5fa', '#818cf8',
  '#a78bfa', '#c084fc', '#f472b6', '#fb7185',
];

const AVATAR_PALETTE_DARK = [
  '#a35f5f', '#9c6a48', '#9d7b36', '#738342',
  '#2f8b71', '#2f7f8e', '#4f7fb1', '#666fbc',
  '#7a67b5', '#8c67b0', '#aa648f', '#b0637d',
];

/**
 * Pick a stable palette color for `seed`. `seed` is typically an email
 * so the color sticks across sessions without needing a server field.
 */
export function avatarColor(seed: string, darkMode = false): string {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = seed.charCodeAt(i) + ((hash << 5) - hash);
  }
  const palette = darkMode ? AVATAR_PALETTE_DARK : AVATAR_PALETTE;
  return palette[Math.abs(hash) % palette.length];
}

/**
 * Extract an initial for `name` (fallback: email). Preserves Hangul as-is
 * so Korean users see their own character rather than a romanized guess.
 */
export function avatarInitial(
  name?: string | null,
  email?: string | null,
): string {
  const src = (name || email || '?').trim();
  const first = src.charAt(0);
  return /[\u3131-\uD79D]/.test(first) ? first : first.toUpperCase();
}
